export default "__VITE_ASSET__BL8_CUc3__"